import api from './axios';

// Authentication API services

/**
 * Login with email and password (local authentication)
 */
export const loginLocal = async (email, password) => {
  const response = await api.post('/api/auth/login', { email, password });
  console.log(response);
  return response.data;
};

/**
 * Register new user with Azure AD
 */
export const registerWithAzure = async (userData, accessToken) => {
  const response = await api.post('/api/auth/register-azure', userData, {
    headers: { Authorization: `Bearer ${accessToken}` }
  });
  return response.data;
};

/**
 * Register new user locally
 */
export const registerLocal = async (userData) => {
  const response = await api.post('/api/auth/register', userData);
  return response.data;
};

/**
 * Get current user profile
 */
export const getCurrentUser = async (accessToken) => {
  const response = await api.get('/api/auth/me', {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
  });
  return response.data;
};

/**
 * Update user profile
 */
export const updateProfile = async (userData) => {
  const response = await api.put('/api/auth/profile', userData);
  return response.data;
};

/**
 * Logout
 */
export const logout = async () => {
  const response = await api.post('/api/auth/logout');
  return response.data;
};

// ================== Password Reset ==================

export const requestPasswordReset = async (email, newPassword) => {
  const response = await api.post('/api/auth/forgot-password', { email, newPassword });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await api.post('/api/auth/reset-password', { token, newPassword });
  return response.data;
};

// ================== Two-Factor Authentication ==================

/** Generate 2FA secret + QR code URI */
export const setup2fa = async () => {
  const response = await api.post('/api/auth/2fa/setup');
  return response.data;
};

/** Verify TOTP code to enable 2FA */
export const enable2fa = async (code) => {
  const response = await api.post('/api/auth/2fa/enable', { code });
  return response.data;
};

/** Disable 2FA (requires valid TOTP code) */
export const disable2fa = async (code) => {
  const response = await api.post('/api/auth/2fa/disable', { code });
  return response.data;
};

// ================== Change Password ==================

export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.post('/api/auth/change-password', { currentPassword, newPassword });
  return response.data;
};
